module.exports = __webpack_public_path__ + "img/newyear_bg.16342fb3.jpg";